import React from 'react';

import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

import classes from './SerialNumberRequirements.module.css';

const serialNumberRequirements = props => {
    return (
        <Popper
            className={classes.SerialNumberPopper}
            open={props.open}
            anchorEl={props.anchorEl}
            placement={props.placement}
            transition
        >
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Paper className={classes.SerialNumberRequirements}>
                        <span>Serial Number Requirements:</span>
                        <ul>
                            <li>Serial Number must be in the following format: </li>
                            <li>#####-#####-#####-#####-#####</li>
                            <li>Serial Number must start with an H or S.</li>
                            <li>Serial Number must contain uppercase letters only.</li>
                            <li>Groups of five characters must be seperated by a dash.</li>
                        </ul>
                    </Paper>
                </Fade>
            )}
        </Popper>
    );
};

export default serialNumberRequirements;
